import { create } from "zustand";

export type CheckoutStep =
  | "idle"
  | "choosing"
  | "processing"
  | "polling"
  | "success"
  | "error";

export type PaymentMode = "cash" | "card";

interface CheckoutResult {
  mode: PaymentMode;
  totalCents: number;
  taxCents: number;
  paymentId?: string;
}

interface CheckoutState {
  step: CheckoutStep;
  paymentMode: PaymentMode | null;
  orderId: string | null;
  checkoutId: string | null;
  result: CheckoutResult | null;
  errorMessage: string | null;

  startChoosing: () => void;
  startProcessing: (mode: PaymentMode) => void;
  setOrderId: (orderId: string) => void;
  startPolling: (checkoutId: string) => void;
  succeed: (result: CheckoutResult) => void;
  fail: (message: string) => void;
  reset: () => void;
}

const initialState = {
  step: "idle" as CheckoutStep,
  paymentMode: null as PaymentMode | null,
  orderId: null as string | null,
  checkoutId: null as string | null,
  result: null as CheckoutResult | null,
  errorMessage: null as string | null,
};

export const useCheckoutStore = create<CheckoutState>()((set) => ({
  ...initialState,

  startChoosing: () =>
    set({ ...initialState, step: "choosing" }),

  startProcessing: (mode) =>
    set({ step: "processing", paymentMode: mode, errorMessage: null }),

  setOrderId: (orderId) =>
    set({ orderId }),

  startPolling: (checkoutId) =>
    set({ step: "polling", checkoutId }),

  succeed: (result) =>
    set({ step: "success", result }),

  fail: (message) =>
    set({ step: "error", errorMessage: message }),

  reset: () =>
    set(initialState),
}));
